import React, { startTransition, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RIACLiveNagPopup } from 'src/components/RIACLiveNagPopup/RIACLiveNagPopup';
import { AgeVerificationCheck } from 'src/components/AgeVerificationCheck/AgeVerificationCheck';

export const PopupController: React.FC<React.PropsWithChildren<object>> = ({ children }) => {
  const [isVerified, setIsVerified] = useState<boolean>(true);
  const [isMounted, setIsMounted] = useState<boolean>(false);
  const [isInitialAgeVerificationNeeded, setIsInitialAgeVerificationNeeded] = useState<boolean>(false);

  const location = useLocation();
  const initialPathname = useRef<string>(location.pathname);
  const isNotInitialPathName = location.pathname !== initialPathname.current;

  useEffect(() => {
    if(window.localStorage.getItem('ageVerified') !== 'true') {
      startTransition(() => {
        setIsVerified(false);
        setIsInitialAgeVerificationNeeded(true);
      });
    }
    startTransition(() => setIsMounted(true));
  }, []);

  if(!isMounted) return null;

  // Age verification precedence
  if(!isVerified) {
    return (
      <AgeVerificationCheck
        isOpen
        onValidDate={() => {
          window.localStorage.setItem('ageVerified', 'true');
          setIsVerified(true);
        }}
        onInvalidDate={() => {
          window.location.href = 'https://www.google.com';
        }}
      />
    );
  }

  // Otherwise, show the live nag only on initial page load and when no age-popup suppressed it
  if(isVerified && !isNotInitialPathName && !isInitialAgeVerificationNeeded) {
    return (
      <>
        <RIACLiveNagPopup />
      </>
    );
  }

  return null;
};
